export default {
  dashboardStatistics: state => {
    return state.dashboard.statistics
  },

  isAuthenticated: state => {
    return state.user.token !== null
  },

  getGuestToken: state => {
    return state.guestToken
  },

  getLoading: state => {
    return state.loading
  },

  getUserData: state => {
    return state.user
  },

  getUserRole: state => {
    return state.user.authorities
  },

  isTranslator: (state, getters) => {
    return Object.values(getters.getUserRole).includes("ROLE_TRANSLATOR")
  },

  isTurkish: (state, getters) => {
    return Object.values(getters.getUserRole).includes("ROLE_TURKISH")
  },

  isOwiwi: (state, getters) => {
    return Object.values(getters.getUserRole).includes("ROLE_OWIWI")
  },

  getUserFirstName: state => {
    return state.user.firstName
  },

  candidatesData: state => {
    return state.candidates.data
  },

  candidatesPaginationData: state => {
    return state.candidates.pagination
  },

  recruitersData: state => {
    return state.recruiters.data
  },

  profilePositionsData: state => {
    return state.profilePositions.data
  },

  recruitersPaginationData: state => {
    return state.recruiters.pagination
  },

  matchmakingPositionData: state => {
    return state.matchmaking.positions
  },

  origins: state => {
    return state.origins
  }
}
